import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Response } from 'crono-fe-common/types/response';
import type { IScoreInstance } from 'crono-fe-common/types/leadScore';

export const useRefreshProspectScore = () => {
  const queryClient = useQueryClient();

  const refreshProspectScore = (prospectId: string) => {
    return client({
      url: `${ENDPOINTS.score.prospect.refresh}`,
      config: {
        method: 'post',
        data: {
          prospectId,
        },
      },
    });
  };

  return useMutation<Response<IScoreInstance>, CronoError, string>(
    refreshProspectScore,
    {
      onSuccess: (_, variable) => {
        queryClient.invalidateQueries([
          ENDPOINTS.score.prospect.main,
          variable,
        ]);
        queryClient.invalidateQueries([ENDPOINTS.prospect.search.main]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.details]);
        queryClient.invalidateQueries([ENDPOINTS.prospect.search.strategy]);
        queryClient.invalidateQueries([ENDPOINTS.task.search]);
        queryClient.invalidateQueries([ENDPOINTS.task.main]);
        queryClient.invalidateQueries([ENDPOINTS.task.overdue]);
        queryClient.invalidateQueries([ENDPOINTS.prospect.main, variable]);
        queryClient.invalidateQueries([ENDPOINTS.account.prospects.search]);
      },
    },
  );
};
